<template>
  <div ref="container" class="experience-privileges-container" :class="isPhone ? 'pt-0' : ''">
    <div class="scrolling-content clubb-hortense">
      <h2 :class="isPhone ? 'merriweather-reg-20 px-3 mb-1' : 'merriweather-reg-24 px-5'">Le Club Hortense</h2>
      <h3 :class="isPhone ? 'merriweather-light-18 px-3' : 'merriweather-light-20 px-5'">Des privilèges exclusifs à chaque séjour</h3>
      <!-- <div v-if="!isPhone" class="benefits benefits-card">
        <div class="text-content" data-aos="fade-right" data-aos-duration="900">
          <h4 class="card-title mt-4 raleway-semi-p20">GREEN EXPÉRIENCE</h4>
          <p class="raleway-reg-15">
            Pour tout séjour de <span class="raleway-semi-p15">plus de 3 nuits</span>, Hortense vous offre
            une expérience unique qui vous transportera au coeur de
            l'atmosphère unique de ce lieu d'exception.
          </p>
          <ul  class="card-title raleway-semi-p15 text-green pl-3" v-if="lodging.lodging_description.green_experience">
            <li>
              <a :href="lodging.private_area_url">{{ lodging.lodging_description.green_experience }}</a>
            </li>
          </ul>
        </div>
      </div> -->

      <div class="advantages mt-4" :class="isPhone ? 'px-3' : 'px-5'">
        <h3 :class="isPhone ? 'raleway-semi-p15' : 'raleway-semi-p20'">PARCE QUE VOUS ÊTES MEMBRE, CHAQUE SÉJOUR DEVIENT UN PRIVILÈGE</h3>
        <p class="raleway-reg-p15">
          Avec le Club Hortense, chaque nouveau statut atteint vous donne accès à des privilèges exclusifs pensés pour sublimer chacun de vos séjours. Cumulables, ces privilèges vous permettent de profiter jusqu’à 4 privilèges exclusifs au cours d’un même séjour. Plus vous voyagez avec Hortense, plus vous êtes récompensé(e).
        </p>
        <div class="shared-mobile-scroll-wrapper" data-aos="fade-up" data-aos-duration="900">
          <div class="gauge-container">
            <div class="status-indicator" :style="statusArrowStyle">
              <div class="status-arrow">
                <span class="text-green" :class="!user ? 'custom-text' : '' ">{{ !user ? 'Connectez-vous pour connaitre votre statut' : 'Votre statut'}}</span>
              </div>
            </div>
            <div class="scroll-sync-wrapper">
              <div class="gauge-scroll-wrapper" :class="!user ? 'custom-text-bar' : ''">
                <div class="scroll-inner">
                <div class="gauge-grid">
                  <div class="gauge-section">
                    <div class="gauge-label">500 points</div>
                    <div class="gauge-bar">
                      <div class="gauge-progress"></div>
                      <div class="gauge-checkpoint">
                        <i class="fas fa-check"></i>
                      </div>
                    </div>
                  </div>
                  <div class="gauge-section">
                    <div class="gauge-label">1000 points</div>
                    <div class="gauge-bar">
                      <div class="gauge-progress"></div>
                      <div class="gauge-checkpoint">
                        <i class="fas fa-check"></i>
                      </div>
                    </div>
                  </div>
                  <div class="gauge-section">
                    <div class="gauge-label">1500 points</div>
                    <div class="gauge-bar">
                      <div class="gauge-progress"></div>
                      <div class="gauge-checkpoint">
                        <i class="fas fa-check"></i>
                      </div>
                    </div>
                  </div>
                  <div class="gauge-section">
                    <div class="gauge-label">2500 points</div>
                    <div class="gauge-bar">
                      <div class="gauge-progress"></div>
                      <div class="gauge-checkpoint">
                        <i class="fas fa-check"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
          <!-- <div class="privilege-cards-wrapper"> -->
            <div class="privilege-cards">
              <div
                v-for="card in privilegeCards"
                :key="card.title"
                :class="['privilege-card', { disabled: card.disabled || !user }]"
              >
                <h3 class="card-title big">
                  GREEN TROTTER {{ card.suffix }}
                </h3>
                <p class="small">
                  {{ card.points }} points = {{ card.nights }} nuits
                  réservées sur Hortense
                </p>
                <img v-if="card.image" :src="card.image" :alt="card.title" />
                <ul class="privilege-list">
                  <li
                    v-for="(privilege, index) in card.privileges"
                    :key="index"
                    :class="{
                      active: privilege.active,
                      locked: !privilege.active,
                    }"
                  >
                    <i
                      :class="
                        privilege.active ? 'fas fa-check' : 'fas fa-lock'
                      "
                    ></i>
                    <span>{{ privilege.text }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
            </div>
          <!-- </div> -->
        </div>
        <div v-if="!user" class="mobile-auth-buttons">
          <button class="auth-btn" @click="$emit('open-login')">ME CONNECTER</button>
          <button class="auth-link raleway-semi-p15 text-green" @click="$emit('open-signup')">Créer mon compte</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReservationCard from "../cards/ReservationCard.vue";
import CommonDatePicker from "../shared/CommonDatePicker.vue";

export default {
  name: "LodgingshowExperienceAndPrivileges",
  components: {
    ReservationCard,
    CommonDatePicker,
  },
  props: {
    lodging: Object,
    user: Object,
    minNights: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      isExpand: true,
      sidebarTop: 0,
      containerHeight: 0,
      containerTop: 0,
      experiences: [
        {
          title: "EXAMPLE TEXT 1",
          image:
            "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/hortense-experience-exclusive.webp",
          items: [{ text: "An element" }],
        },
        {
          title: "EXAMPLE TEXT 2",
          image:
            "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/hortense-experience-bien-etre.webp",
          items: [
            { text: "An element" },
            { text: "An element" },
            { text: "An element" },
          ],
        },
        {
          title: "EXAMPLE TEXT 3",
          image:
            "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/hortense-experience-locale.webp",
          items: [
            { text: "An element", link: "#" },
            { text: "An element", link: "#" },
          ],
        },
      ],
      startDate: null,
      endDate: null,
      guestNumber: null,
      isSearching: false,
      show_resa_card: false,
      roomOptions: [],
      availabilitiesNotKoedia: [],
      tariffsNotKoedia: [],
      lodgingTax: null,
      touristTax: null,
      nights: null,
      from: null,
      to: null,
      accommodation_code: null,
      searched: false,
      minDate: new Date(),
      maxDate: new Date(
        new Date().setFullYear(new Date().getFullYear() + 1)
      ),
    };
  },
  computed: {
    availabilitySearchButtonCaption() {
      return this.isSearching
        ? "Recherche en cours..."
        : "Vérifier les disponibilités";
    },
    isPhone() {
      return window.innerWidth <= 768;
    },
    privilegeCards() {
      const cardTemplates = [
        {
          title: "Green Trotter",
          suffix: "",
          points: "500",
          nights: "10",
        },
        {
          title: "Green Trotter PLUS",
          suffix: "PLUS",
          points: "1000",
          nights: "20",
        },
        {
          title: "Green Trotter PREMIUM",
          suffix: "PREMIUM",
          points: "1500",
          nights: "30",
        },
        {
          title: "Green Trotter INFINITE",
          suffix: "INFINITE",
          points: "2500",
          nights: "50",
        },
      ];

      const normalizeName = name =>
        name.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

      const allGifts = Array.from(
        new Map(
          this.lodging.green_trotters
            .flatMap(gt => gt.gifts || [])
            .map(gift => [normalizeName(gift.name), gift])
        ).values()
      );
        console.log('allGifts', allGifts)
      return this.lodging.green_trotters.map(
        (greenTrotter, index) => {
          const template = cardTemplates[index] || {};
          const currentGifts = greenTrotter.gifts || [] ;
          const isActive =
            this.user &&
            ((this.currentTier === "" && template.suffix === "") ||
            this.currentTier === template.suffix);
          console.log('isActive', isActive)
          console.log('currentTier', this.currentTier)
          console.log('template.suffix', template.suffix)
          return {
            ...template,
            disabled: !isActive,
            image:
              currentGifts.length > 0 && greenTrotter.photo_url
                ? greenTrotter.photo_url
                : "",
            privileges: allGifts.map((gift) => ({
              text: gift.name,
              active: currentGifts.some((g) => g.name === gift.name),
            })),
          };
        }
      );
    },
    statusArrowStyle() {
      const points = this.user?.loyalty_points || 0;
      // Checkpoints aligned with grid sections (middle of each section)
      const checkpoints = [500, 1000, 1500, 2500];
      const gridSectionCenters = [12.5, 37.5, 62.5, 87.5]; // % positions of section middles
      
      // Cap points at maximum checkpoint
      const cappedPoints = Math.min(points, checkpoints[checkpoints.length - 1]);
      
      let position = 0;
      
      if (cappedPoints <= checkpoints[0]) {
        // Before or at first checkpoint (0 to 500)
        // Position from 0% to 12.5% (start to middle of first section)
        position = (cappedPoints / checkpoints[0]) * gridSectionCenters[0];
      } else if (cappedPoints <= checkpoints[1]) {
        // Between 1st and 2nd checkpoint (500 to 1000)
        // Position from 12.5% to 37.5%
        const range = checkpoints[1] - checkpoints[0];
        const progress = (cappedPoints - checkpoints[0]) / range;
        position = gridSectionCenters[0] + (progress * (gridSectionCenters[1] - gridSectionCenters[0]));
      } else if (cappedPoints <= checkpoints[2]) {
        // Between 2nd and 3rd checkpoint (1000 to 1500)
        // Position from 37.5% to 62.5%
        const range = checkpoints[2] - checkpoints[1];
        const progress = (cappedPoints - checkpoints[1]) / range;
        position = gridSectionCenters[1] + (progress * (gridSectionCenters[2] - gridSectionCenters[1]));
      } else if (cappedPoints <= checkpoints[3]) {
        // Between 3rd and 4th checkpoint (1500 to 2500)
        // Position from 62.5% to 87.5%
        const range = checkpoints[3] - checkpoints[2];
        const progress = (cappedPoints - checkpoints[2]) / range;
        position = gridSectionCenters[2] + (progress * (gridSectionCenters[3] - gridSectionCenters[2]));
      } else {
        // Beyond final checkpoint
        position = gridSectionCenters[3];
      }
      
      // Arrow is 28px wide, so offset it by half width to center it
      const arrowOffset = 30; // half of 28px arrow width
      if (position <= 7) {
        return { left: `calc(${position}%)` };
      }
      return {
        left: `calc(${position}% - ${arrowOffset}px)`
      };
    },
    currentTier() {
      const points = this.user?.loyalty_points || 0;
      console.log('this.user?.loyalty_points', this.user?.loyalty_points || 0)
      if (points >= 2000) return "INFINITE";
      if (points >= 1500) return "PREMIUM";
      if (points >= 1000) return "PLUS";
      if (points >= 500) return "";
      return null;
    }
  },
  mounted() {
    this.initializePositions();
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.initializePositions);
    // const wrapper = this.$el.querySelector('.scroll-sync-wrapper');
    // const gauge = this.$el.querySelector('.gauge-scroll-wrapper');
    // const cards = this.$el.querySelector('.privilege-cards');

    // wrapper.addEventListener('scroll', () => {
    //   gauge.scrollLeft = wrapper.scrollLeft;
    //   cards.scrollLeft = wrapper.scrollLeft;
    // });
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.initializePositions);
  },
  methods: {
    initializePositions() {
      // const container = this.$refs.container;
      // const sidebar = this.$refs.sidebar;
      // if (!container || !sidebar) return;

      // this.containerTop = container.offsetTop;
      // this.containerHeight = container.offsetHeight;
      // this.sidebarTop = 100;
    },
    handleScroll() {
      // const container = this.$refs.container;
      // const sidebar = this.$refs.sidebar;
      // const stickyContent = sidebar.querySelector(".sticky-content");
      // if (!container || !sidebar || !stickyContent) return;

      // const containerRect = container.getBoundingClientRect();
      // const sidebarHeight = stickyContent.offsetHeight;
      // const scrollY = window.scrollY;
      // const endPoint =
      //   this.containerTop + this.containerHeight - sidebarHeight;

      // if (containerRect.top >= 0) {
      //   sidebar.style.position = "absolute";
      //   sidebar.style.top = `${containerRect.top}px`;
      // } else if (scrollY > endPoint) {
      //   sidebar.style.position = "absolute";
      //   sidebar.style.top = `${
      //     this.containerHeight - sidebarHeight
      //   }px`;
      // } else {
      //   sidebar.style.position = "fixed";
      //   sidebar.style.top = `${this.sidebarTop}px`;
      // }

      // sidebar.style.visibility =
      //   containerRect.bottom < 0 ||
      //   containerRect.top > window.innerHeight
      //     ? "hidden"
      //     : "visible";
    },
    selectDates(event) {
      this.startDate = event.start;
      this.endDate = event.end;
    },
    async checkIfAvailable(startDate, endDate, guestNumber) {
      if (!startDate || !endDate || !guestNumber) {
        return;
      }

      this.isSearching = true;
      this.show_resa_card = false;
      this.searched = true;

      try {
        const response = await fetch(
          `/api/v1/lodgings/${this.lodging.id}/availability`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              start_date: startDate,
              end_date: endDate,
              guest_number: guestNumber,
            }),
          }
        );

        const data = await response.json();

        this.roomOptions = data.roomOptions || [];
        this.availabilitiesNotKoedia =
          data.availabilitiesNotKoedia || [];
        this.tariffsNotKoedia = data.tariffsNotKoedia || [];
        this.lodgingTax = data.lodgingTax;
        this.touristTax = data.touristTax;
        this.nights = data.nights;
        this.from = startDate;
        this.to = endDate;
        this.accommodation_code = data.accommodation_code;

        this.show_resa_card = true;
      } catch (error) {
        console.error(
          "Erreur lors de la vérification de disponibilité:",
          error
        );
      } finally {
        this.isSearching = false;
      }
    },
    displayUserInfo(
      room,
      pricePerNightTtc,
      totalTtc,
      koediaRoomAvailability,
      idx,
      tva,
      priceHt
    ) {
      this.$emit("display-user-info", {
        room,
        pricePerNightTtc,
        totalTtc,
        koediaRoomAvailability,
        idx,
        tva,
        priceHt,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$font-family-base: "Raleway", sans-serif;
$font-weight-base: normal;

.gauge-label {
  font-family: $Raleway;
  font-weight: 400;
  font-size: 15px;
}
.experience-privileges-container {
  display: grid;
  grid-template-columns: 100%;
  gap: 2rem;
  position: relative;
  padding: 2rem 0;
  max-width: 100%;
}

.scrolling-content {
  width: 100%;
}

.fixed-sidebar {
  position: relative;
  width: 100%;
  pointer-events: none;
}

.sidebar-wrapper {
  width: 30%;
  position: fixed;
  right: 0;
  padding-right: calc((100% - 1140px) / 2 + 2rem);
}

.sticky-content {
  padding-left: 2rem;
  border-left: 1px solid #e0e0e0;
  pointer-events: auto;
  width: 100%;
}

.sticky-content-subtitle {
  font-family: Raleway;
  font-weight: bold;
  font-size: 1rem;
  margin: 1rem;
  text-align: center;
}

.experience-hortense {
  padding: 40px 20px;
  position: relative;
}

.cards-container {
  display: flex;
  gap: 2rem;
  justify-content: space-between;
}

.card-experience {
  flex: 1;
  max-width: calc(33.33% - 1.33rem);
}

.card-experience img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  margin-bottom: 1rem;
}

.card-content {
  text-align: left;
}

.card-title {
  font-family: Raleway;
  font-weight: bold;
  margin-bottom: 1rem;
  text-transform: uppercase;
  .link {
    color: #3b6152;
    font-size: 0.9rem;
    &:hover {
      text-decoration: none;
    }
  }
  .fa-check {
    color: #3b6152;
    margin-right: 1rem;
  }
}

.benefits-card {
  background: #CFE5DC4D 0% 0% no-repeat padding-box;
  border-radius: 0px 10px 10px 0px;
  opacity: 1;
  padding: 24px 30px 30px 52px;
}

.advantages {
  .gauge-container {
    position: relative;
    padding: 2rem 0;
    
    @media screen and (min-width: 700px) {
      padding-left: 5%;
      padding-right: 5%;
    }

    @media screen and (max-width: 480px) {
      padding: 0.5rem 0;
    }
  }

  .status-indicator {
    position: relative;
    height: 40px;
    margin-bottom: 0;
    z-index: 1;

    .status-arrow {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: absolute;
      left: 1%;

      span {
        position: relative;
        margin-left: 60px;
        margin-bottom: 1px;
        padding: 0.5rem;
        border: 1px solid #2C5E4B;
        border-radius: 15px;
      }
      span::after {
        content: "";
        position: absolute;
        bottom: -6px;
        left: 30%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 6px solid #2C5E4B;
      }

      i {
        font-size: 20px;
        color: #cbcbcb;
        transform: rotate(180deg);
      }
    }
  }

  .gauge-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0;
    width: 100%;
  }

  .gauge-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    .gauge-label {
      margin-bottom: 1.3rem;
      text-align: center;
      font-weight: 500;
    }

    .gauge-bar {
      position: relative;
      width: 100%;
      height: 13px;
      background: #e0e0e0;

      .gauge-progress {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        background-color: #a5d3ae;
      }

      .gauge-checkpoint {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 28px;
        height: 28px;
        background: white;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          font-size: 18px;
          color: #3b6152;
        }
      }
    }

    /* Green gauge stops in the middle of last element */
    &:last-child .gauge-progress {
      width: 50%;
    }

    .card {
      background-color: #cfe5dc;
    }
  }
}

.privilege-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  margin-top: 2rem;
}

.privilege-card {
  background: #F5F5F5 0% 0% no-repeat padding-box;
  padding: 1.5rem;
  border-radius: 15px;

  &.disabled {
    background-color: #e0e0e0;
    opacity: 0.5;
  }

  .card-title {
    text-align: center;
    font-weight: 600;
    margin-bottom: 0.5rem;
    text-transform: none;
    &.big {
      font-size: 15px;
      color: #3B6152;
    }
  }

  .small {
    text-align: center;
    margin-bottom: 1rem;

    @media screen and (max-width: 480px) {
      margin-bottom: 0.5rem;
    }
  }

  img {
    width: 100%;
    height: 170px;
    margin-bottom: 1rem;
    border-radius: 15px;
  }

  .privilege-list {
    list-style: none;
    padding: 0;
    margin: 0;
    font-size: 0.85rem;

    li {
      display: flex;
      align-items: center;
      text-transform: uppercase;

      &:last-child {
        margin-bottom: 0;
      }

      i {
        margin-right: 0.8rem;
        font-size: 1.1em;
      }

      &.active {
        i {
          color: #3b6152;
        }
        span {
          color: inherit;
          font: normal normal 600 11px/35px Raleway;
          @media screen and (max-width: 480px) {
            line-height: 1.2rem;
          }
        }
      }

      &.locked {
        i {
          color: #999;
        }
        span {
          color: #999;
          font: normal normal 300 11px/35px Raleway;
          @media screen and (max-width: 480px) {
            line-height: 1.2rem;
          }
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .sidebar-wrapper {
    padding-right: 2rem;
  }
}

@media (max-width: 768px) {
  .privilege-card {
  max-width: 260px;
}
  .benefits-card {
  padding: 1rem !important;

  .text-content {
    padding: 1rem !important;
    width: 100% !important;
    box-sizing: border-box;
  }

  p {
    font-size: 15px;
    line-height: 1.5;
    word-break: break-word;
  }

  a.link {
    display: inline-block;
    font-weight: 700;
    font-size: 14px;
    white-space: normal;
    word-break: break-word;
  }
}

  .experience-privileges-container {
    grid-template-columns: 1fr;
    gap: 3rem;
  }
  .fixed-sidebar {
    order: -1;
    pointer-events: auto;
  }

  .sidebar-wrapper {
    position: relative;
    width: 100%;
    padding-right: 0;
  }

  .sticky-content {
    position: relative;
    border-left: none;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 2rem;
    padding-left: 0;
    width: 100%;
  }

  .cards-container {
    flex-direction: column;
  }

  .card-experience {
    max-width: 100%;
  }

}
.status-indicator {
  position: relative;
    height: 40px;
    margin-bottom: -25px;
    z-index: 1;
}

.status-arrow {
  position: absolute;
  top: 0;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
}

.privilege-cards-wrapper {
  width: 100%;
  overflow-x: auto;

  @media (min-width: 769px) {
    overflow-x: unset;
  }
}

.privilege-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 13px;
  margin-top: 1.5rem;

  @media (max-width: 768px) {
    display: flex;
    flex-wrap: nowrap;
    gap: 13px;
    min-width: 1100px;
  }
}

.privilege-card {
  min-width: 250px;
  flex: 0 0 auto;

  @media (min-width: 769px) {
    min-width: unset;
  }
}

.mobile-auth-buttons {
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 1rem;
  }

  .auth-btn {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    color: white;
    text-decoration: none;
    background-color: #3b6152;
    padding: 16px 36px;
    text-transform: uppercase;
    font-family: Raleway, sans-serif;
    font-weight: 700;
    font-size: 13px;
    margin-bottom: 1rem;
  }

  .auth-link {
    font-family: Raleway, sans-serif;
    font-size: 13px;
    font-weight: 500;
    text-decoration: underline;
    color: #000;
    display: inline-block;
  }
}

@media (max-width: 768px) {
  .scrolling-content {
    overflow-x: hidden;
    overflow-y: auto;
  }

  .experience-privileges-container {
    display: block;
    padding: 1rem 0;
  }

  .scroll-sync-wrapper {
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
  -webkit-overflow-scrolling: touch;
}

  .scroll-inner {
    display: flex;
    flex-direction: column;
    min-width: 1100px;
  }

  .gauge-scroll-wrapper,
  .privilege-cards {
    width: 100%;
  }
  


  .gauge-scroll-wrapper,
  .privilege-cards {
    display: grid;
    grid-template-columns: repeat(4, 1fr); 
    min-width: 1100px;
    scroll-snap-align: start;
  }

  .scroll-sync-wrapper::-webkit-scrollbar {
      display: none;
    }


}

.gauge-scroll-wrapper {
  width: 100%;

  @media (max-width: 768px) {
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 1rem;
  }
}

.gauge-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0;
  width: 100%;

  @media (max-width: 768px) {
    display: flex;
    flex-wrap: nowrap;
    min-width: 1100px;
  }
}

.gauge-section {
  scroll-snap-align: start;

  @media (max-width: 768px) {
    flex: 0 0 200px;
    text-align: center;
  }
}

@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  .advantages {
    .status-indicator {
      z-index: 0 !important;
    }
  }
}
.text-green {
  color: #2C5E4B;
}

@media (max-width: 768px) {
  .custom-text {
    height: 79px;
    width: 113px;
    left: 5%;
  }

  .custom-text-bar {
    padding-top: 10%;
  }
}
</style>
